import { EtatDocumentPa, TypeDocumentPa } from "../entities/document-pa.entity";

export class PaSearchCriteria {
	numeroPa!: string;
	agence?: number;
	antenne?: number;
	groupement?: number;
	parc?: number;
	entreprise?: number;
	typePa!: TypeDocumentPa[];
	etat!: EtatDocumentPa[];
	validite!: number[];
	monPerimetreReferent!: boolean;
	currentUserId?: number;
	archive!: boolean;
}